import { render, staticRenderFns } from "./SelectPatients.vue?vue&type=template&id=63f1028c&scoped=true&"
import script from "./SelectPatients.vue?vue&type=script&lang=ts&"
export * from "./SelectPatients.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPatients.vue?vue&type=style&index=0&id=63f1028c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1028c",
  null
  
)

export default component.exports